(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfWhenScroll', function() {
    return {
      link: function(scope, element, attrs) {
        var elem;
        elem = element[0];
        return element.bind('scroll', debounce(function() {
          var location;
          location = elem.scrollTop + elem.offsetHeight + 5;
          if (location >= elem.scrollHeight) {
            return scope.$apply(attrs.mfWhenScroll);
          }
        }, 500));
      }
    };
  });

}).call(this);
